import React from "react";
import { Loader2 } from "lucide-react";

interface AuthButtonProps {
  type?: "button" | "submit";
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
}

export default function AuthButton({
  type = "button",
  onClick,
  children,
  className = "",
  disabled = false,
  loading = false,
}: AuthButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`w-full font-semibold py-3 px-2 rounded-lg transition-all duration-200 transform focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-dark-950 shadow-sm ${
        disabled || loading
          ? "bg-gray-300 dark:bg-dark-600 text-gray-500 dark:text-dark-400 cursor-not-allowed"
          : "bg-primary-600 hover:bg-primary-700 text-white hover:scale-[1.02] focus:ring-primary-500"
      } ${className}`}
    >
      <div className="flex items-center justify-center gap-2">
        {loading && <Loader2 className="h-4 w-4 animate-spin" />}
        {children}
      </div>
    </button>
  );
}
